import React from "react";

interface SettingTileProps {
    name: string,
    form: React.JSX.Element,
    icon?: boolean | React.JSX.Element,
    desc?: string
}


export function SettingTile(props: SettingTileProps) {

    let icon = props.icon;
    if (icon === true) {
        icon =
            <svg className="w-6 h-6 text-gray-500 group-hover:text-gray-900" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 90 90">
                <path d="m82.3 32.54c-2.685 0-5.092-1.544-6.326-3.929-0.246-0.475-0.504-0.948-0.774-1.416s-0.55-0.928-0.839-1.378c-1.448-2.26-1.582-5.118-0.24-7.443 1.95-3.377 0.793-7.695-2.584-9.645l-9.353-5.4c-3.377-1.95-7.695-0.793-9.645 2.584l-2e-3 3e-3c-1.323 2.291-3.814 3.641-6.456 3.512-1.148-0.056-2.301-0.056-3.455 0-2.637 0.128-5.123-1.226-6.443-3.513l-1e-3 -2e-3c-1.95-3.377-6.268-4.534-9.645-2.584l-9.353 5.4c-3.377 1.95-4.534 6.268-2.584 9.645l1e-3 2e-3c1.32 2.286 1.25 5.116-0.179 7.336-0.625 0.971-1.202 1.97-1.727 2.992-1.209 2.353-3.624 3.835-6.27 3.835h0.636c-3.9 0-7.061 3.162-7.061 7.061v10.8c0 3.9 3.161 7.061 7.061 7.061v0c2.685 0 5.092 1.544 6.326 3.929 0.246 0.475 0.504 0.947 0.774 1.416 0.27 0.468 0.55 0.928 0.839 1.378 1.448 2.26 1.582 5.118 0.24 7.442-1.95 3.377-0.793 7.696 2.584 9.645l9.353 5.4c3.377 1.95 7.695 0.793 9.645-2.584l2e-3 -3e-3c1.323-2.291 3.814-3.641 6.456-3.512 1.148 0.056 2.301 0.057 3.455 1e-3 2.637-0.128 5.123 1.226 6.443 3.513l1e-3 2e-3c1.95 3.377 6.268 4.534 9.645 2.584l9.353-5.4c3.377-1.95 4.534-6.268 2.584-9.645l-1e-3 -2e-3c-1.32-2.286-1.25-5.116 0.179-7.336 0.625-0.971 1.201-1.97 1.727-2.992 1.209-2.353 3.624-3.835 6.27-3.835h4e-3c3.9 0 7.061-3.161 7.061-7.061v-10.801c-1e-3 -3.899-3.162-7.06-7.062-7.06zm-27.302 29.778c-9.564 5.522-21.794 2.245-27.316-7.319s-2.245-21.794 7.319-27.316 21.794-2.245 27.316 7.319c5.523 9.564 2.246 21.794-7.319 27.316z" />
            </svg>;
    }

    return (
        <div className="relative overflow-hidden bg-transparent h-14 p-1 m-1 rounded-lg shadow">
            <div className="inline-flex items-center h-full w-full">
                <div className="h-full w-3/4">
                    <div className="inline-flex items-center divide-x divide-gray-400 h-full">
                        {(icon != null && icon !== false) &&
                            <div className="w-16 flex justify-center">
                                {icon}
                            </div>
                        }
                        <div className="w-full px-5 text-gray-700">
                            <h1 className="text-md font-medium"> {props.name} </h1>
                            <h5 className="text-sm text-gray-500"> {props.desc} </h5>
                        </div>
                    </div>
                </div>

                <div className="w-1/4 h-full">
                    {props.form}
                </div>
            </div>

            <div className="bg-gradient-to-bl from-blue-100 to-gray-100 w-full h-full absolute top-0 left-0 -z-10"></div>
        </div>
    );

}
